import React from "react";
import "../styles/App.css";
import { CkComponents, ckAPIMethods } from "chat-kit";
import avatarImg from "../assets/Logo.png";
console.log(avatarImg)
ckAPIMethods.settings("changeAvatar", avatarImg);
const App = () => {
  const { ChatIt } = CkComponents;
  return (
    <div className="sova-ck-main">
      <div className="sova-ck-chat">
        <ChatIt ckStore={true} />
      </div>
    </div>
  );
};
export default App;
